/**
 * HomeSupportItemsStore
 * Extends the BaseStore for managing HomeSupportItems.
 */

import BaseStore from '@legacy-src/Datastores/BaseStore';
import { HomeSupportItemInterface } from '@sah/Classes/HomeSupportItem';

class HomeSupportItemsStore extends BaseStore<HomeSupportItemInterface> {}

export default new HomeSupportItemsStore();
